import correctMp3 from "../../../../src/posts/2021-01-31_react-soundboard/sounds/correct.mp3";
import { SoundControlV1 } from "../../../../src/components/Posts/ReactSoundBoard/SoundControlV1";
import { SoundControlV2 } from "../../../../src/components/Posts/ReactSoundBoard/SoundControlV2";
import * as React from 'react';
export default {
  correctMp3,
  SoundControlV1,
  SoundControlV2,
  React
};